// ** utils
import {
  ASSIGNED,
  BLOCKED,
  COMPLETED,
  CUSTOMER,
  FINISHED,
  GUEST,
  H_LIVE_CHAT,
  HOLIDAY,
  POINT,
  REQUESTED,
  SOCKET_NAMESPACE,
  SOCKET_NAMESPACE_NOTIFY,
  SOCKET_URI,
  TEXT,
  TOKEN_STORAGE,
  WAITING,
  YOUR_IP_ADDRESS_IS_BLOCKED,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_DATABASE_URL,
  FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID,
  SYSTEM,
} from '@constants';
import { commonDateFormat, consoleLogDev, getGenerationRandomString, turnOnAlarm } from '@utils';
import { gtmCloseAssistant, gtmCreateMiniChat, gtmRateMiniChat } from '@gtm';
import { io } from 'socket.io-client';
import useConfigStore from '@constants/hooks/useConfigStore';
import bookingStore from '@store/booking.store';
import { initializeApp } from 'firebase/app';
import { getAuth, signInAnonymously, updateProfile } from 'firebase/auth';

// ** theme
import { Box, Button, TextField, Typography } from '@mui/material';
import { color } from '@theme';
import { styles } from './styles';

// ** react
import { useState, useEffect, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

// ** components
import ChatBubble from '@components/ChatBubble';
import LoadingSpinner from '@components/LottieSpinner';
import Disclaimer from './Disclaimer';
import CustomDialog from './CustomDialog';
import OfflineMessage from './OfflineMessage';
import RatingForm from './RatingForm';
import CustomHeader from './CustomHeader';
import CustomModal from './CustomModal';

// ** images
import icon_send from '@images/icon_send.png';
import icon_send_disabled from '@images/icon_send_disabled.png';
import typing from '@images/typing.png';

// ** apis
import {
  addChatCustomer,
  createHLiveChatRequest,
  getBusinessHourByCountry,
  getCallCenterCustomerHistory,
  getMessageListCustomer,
  getMiniChatToken,
  getPrivacyPolicyByCountryCode,
  updateServiceRequestCustomer,
} from '@apis';

const MiniChatRoomSingle = (props) => {
  const { setMiniChatOpened, channelType, channelLink } = props;

  // ** ---------------------------------------------------------------Store
  const { selectedCountry, selectedLanguage, requestId, setRequestId, setExternalChannelType, setExternalChannelLink } = bookingStore();
  const { FIREBASE_API_KEY, DECRYPT_FIRST_KEY, DECRYPT_SECOND_KEY } = useConfigStore();

  // ** ---------------------------------------------------------------State
  const [isLoading, setIsLoading] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [isDialogOpened, setIsDialogOpened] = useState(false);
  const [message, setMessage] = useState();
  const [sending, setSending] = useState(false);
  const [imageDialogOpen, setImageDialogOpen] = useState();
  const [qualityRating, setQualityRating] = useState(0);
  const [satisfactionRating, setSatisfactionRating] = useState(0);
  const [socketInstance, setSocketInstance] = useState();
  const [socketInstanceNotify, setSocketInstanceNotify] = useState();
  const scrollViewRef = useRef();
  const textFieldRef = useRef();
  const { t } = useTranslation();
  const currentDate = moment().format('DD.MM.YYYY');
  const [isMessageListLoading, setIsMessageListLoading] = useState(false);
  // ** -------------------------------------------------------------State
  const [minichatUrl, setMinichatUrl] = useState();
  const [messages, setMessages] = useState([]);
  const [dealerInfo, setDealerInfo] = useState({});
  const [isOffline, setIsOffline] = useState(false);
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [includeBreakStartTime, setIncludeBreakStartTime] = useState('');
  const [includeBreakEndTime, setIncludeBreakEndTime] = useState('');
  const [isIncludeBreak, setIsIncludeBreak] = useState('');
  const [requestStatus, setRequestStatus] = useState('');
  const [isDisclaimerOpened, setIsDisclaimerOpened] = useState(false);
  const [openEndChatModal, setOpenEndChatModal] = useState(false);
  const [endChat, setEndChat] = useState(false);
  const [canSendMessage, setCanSendMessage] = useState(false);

  // ** -------------------------------------------------------------endchat modal
  const handleEndChatModalClose = () => setOpenEndChatModal(false);

  // ** endchat는 2개 requestStatus 있어요 : COMPLETED 랑 FINISHED있습니다
  // ** close click 하면 Modal나옵니다
  // ** Modal에서 "END" button click하면 handleConfirmEndChat 시행이 됩니다
  // ** 다음으로 조건(rating form 조건:requestStatus: COMPLETED && agent has sent a chat)에 따라서 "SUBMIT"button 나옵니다. click하면 handleSubmit시행이 됩니다.
  // endchat(COMPLETED)
  const handleConfirmEndChat = async () => {
    setOpenEndChatModal(false);
    // endchat(COMPLETED) 필요한 dto
    const dto = {
      requestId,
      writer: SYSTEM,
      template: 'H_LIVE_CHAT_END_CUSTOMER',
      requestStatus,
      dealerCode: dealerInfo?.dealerCode,
      messageContents: 'Chat has been ended by the Customer',
      messageType: TEXT,
    };

    // endchat(COMPLETED) 시 필요한 requestData
    const requestData = {
      requestId,
      requestStatus: requestStatus === ASSIGNED ? 'CUSTOMER_AFK_P' : 'CUSTOMER_AFK_Q',
    };

    try {
      // dto & requestData쓰는 api call
      const response = await addChatCustomer(dto);
      const responseUpdate = await updateServiceRequestCustomer(requestData, DECRYPT_FIRST_KEY, DECRYPT_SECOND_KEY);

      if (response?.success && responseUpdate?.success) {
        //socket(chat) "H_LIVE_CHAT_END"보내기
        socketInstance.emit('chat', {
          roomId: requestId,
          sender: SYSTEM,
          msg: response.data,
          messageType: 'H_LIVE_CHAT_END',
        });

        //Notify socket(terminateChat) 보내기
        // socketInstanceNotify.emit('terminateChat', {
        //   roomId: requestId,
        //   sender: SYSTEM,
        // });

        setEndChat(true);
      }
    } catch (error) {
      console.error('Error ending chat:', error);
    } finally {
      //** call center쪽 보내준 terminateChat message받기 위한 fetch(socket으로 안보내줘는거로 되어있어서 )
      await fetchMessages();
    }
  };

  // ** -------------------------------------------------------------firebase
  // firebaseConfig
  const firebaseConfig = {
    apiKey: FIREBASE_API_KEY,
    authDomain: FIREBASE_AUTH_DOMAIN,
    databaseURL: FIREBASE_DATABASE_URL,
    projectId: FIREBASE_PROJECT_ID,
    storageBucket: FIREBASE_STORAGE_BUCKET,
    messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
    appId: FIREBASE_APP_ID,
    measurementId: FIREBASE_MEASUREMENT_ID,
  };
  const app = initializeApp(firebaseConfig);

  // setFirebaseAuth
  const setFirebaseAuth = async () => {
    const auth = getAuth(app);
    const { user } = await signInAnonymously(auth);
    const tokenStorage = JSON.parse(sessionStorage.getItem(TOKEN_STORAGE));
    const token = tokenStorage?.token;
    if (token) {
      await updateProfile(user, {
        // @ts-ignore - Firebase types don't include customClaims
        customClaims: {
          token,
        },
      });
    }
  };

  // ** ---------------------------------------------------------------click actions
  // handleDisclaimer
  const handleDisclaimer = () => {
    setIsDisclaimerOpened(!isDisclaimerOpened);
  };

  // handleCloseClick
  const handleCloseClick = async () => {
    gtmCloseAssistant();
    if (requestId) {
      setOpenEndChatModal(true);
    }
  };

  // handleFoldClick
  const handleFoldClick = async () => {
    gtmCloseAssistant();
    setMiniChatOpened(false);
  };

  // handleQualityRatingChange
  const handleQualityRatingChange = (rating) => {
    setQualityRating(rating);
  };

  // set Satisfaction Rating
  const handleSatisfactionRatingChange = (rating) => {
    setSatisfactionRating(rating);
  };

  // Submit endchat(FINISHED)
  const handleSubmit = () => {
    updateServiceRequest();
  };

  // endchat(FINISHED) and  update rating
  const updateServiceRequest = async () => {
    const rating = {
      connection: qualityRating,
      satisfaction: satisfactionRating,
    };
    const requestData = {
      requestId,
      requestStatus: FINISHED,
      rating,
    };
    setIsLoading(true);
    try {
      const response = await updateServiceRequestCustomer(requestData, DECRYPT_FIRST_KEY, DECRYPT_SECOND_KEY);

      if (response && requestStatus !== BLOCKED) {
        setRequestStatus(response?.data?.serviceRequest?.requestStatus);
        gtmRateMiniChat(qualityRating, satisfactionRating);
      }
      turnOnAlarm();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  // handleKeyPress
  const handleKeyPress = (e) => {
    e.preventDefault();
    if (e.key === 'Enter') {
      if (message && message.trim() !== '') {
        handleSendButton();
      }
    }
  };

  // Send Button
  const handleSendButton = useCallback(async () => {
    if (!message) return;
    setSending(true);
    try {
      await sendMessage({ message: message, socketInstance });
      setMessage('');
    } catch (e) {
    } finally {
      setSending(false);
    }
  }, [message, socketInstance]);

  // ** ---------------------------------------------------------------send message
  // sendMessage용도: 1.handleSendButton에서 사용, 2.requestId없으면 createRequest 이용후 sendChatMessage, 3.requestId있으면 바로 sendChatMessage
  const sendMessage = async ({ message, socketInstance }) => {
    if (!message) {
      return;
    }

    if (!requestId) {
      // requestId없으면 createRequest api를 통해서 newRequestId를 받고 sendChatMessage를 합니다
      try {
        const newRequestId = await createRequest();
        await sendChatMessage(message, socketInstance, newRequestId, true);
      } catch (error) {
        return;
      }
    } else {
      // requestId있으면 있는 requestId를 이용합니다
      await sendChatMessage(message, socketInstance, requestId, false);
    }
  };

  // sendChatMessage용도: 1.sendMessage에서 사용, 2.socket 이용해서 chat보내기, 3.ASSIGNED하게돼면 notify 하고 Message비우기
  const sendChatMessage = async (message, socketInstance, currentRequestId, isNewSocket) => {
    const dto = {
      requestId: currentRequestId,
      writer: CUSTOMER,
      template: '',
      requestStatus,
      dealerCode: dealerInfo?.dealerCode,
      messageContents: message,
      messageType: TEXT,
    };

    try {
      const response = await addChatCustomer(dto);
      if (response?.message === YOUR_IP_ADDRESS_IS_BLOCKED) {
        setIsDialogOpened(true);
        return;
      }

      // ** isNewSocket : requestId없으면 socket연결이 안됩니다.requestId생기자마작 socket연결해야합니다.
      // ** 그래서 isNewSocket로 구분합니다
      // ** true라면 socket따로 한번 연결해야합니다(이유:requestId 세팅했지만 useState특성상 바로 개신이 안됩니다. ),
      // ** false라면 socket따로 연결할필요 없스니다.
      if (isNewSocket) {
        consoleLogDev(`isNewSocket ${isNewSocket}`);
        const accessToken = getTokenFromStorage();
        const socket = io(SOCKET_URI + SOCKET_NAMESPACE, {
          transports: ['websocket'],
          auth: {
            token: `Bearer ${accessToken}`,
            type: 'MINI_CHAT',
          },
        });
        socket.emit('chat', {
          roomId: currentRequestId,
          sender: CUSTOMER,
          msg: response?.data,
          messageType: TEXT,
        });
      } else {
        consoleLogDev(`isNewSocket ${isNewSocket}`);
        socketInstance.emit('chat', {
          roomId: currentRequestId,
          sender: CUSTOMER,
          msg: response?.data,
          messageType: TEXT,
        });
      }

      if (requestStatus === ASSIGNED) {
        socketInstanceNotify.emit('notify', { roomId: currentRequestId, sender: CUSTOMER });
      }

      // 보낸후 비우기
      setMessage('');
    } catch (error) {
      console.error(error);
    }
  };

  // sendChatMessage용도:  1.sendMessage에서 사용， 2.sendMessage에서 requestId없으면 createRequest 이용， 3.여기서 room(requestId) 만들기
  const createRequest = async () => {
    // requestStatus: REQUESTED를 createHLiveChatRequest api를 통해 보내기
    const createRequestData = {
      location: {
        type: POINT,
        coordinates: [0, 0],
      },
      country: selectedCountry?.countryCode.toUpperCase(),
      bookingDate: '',
      bookingTime: '',
      requestType: H_LIVE_CHAT,
      requestStatus: REQUESTED,
      lastModifier: GUEST,
      liveConsult: true,
      externalChannelType: channelType ? channelType : 'Hyundai Assistant',
      externalChannelLink: channelLink ? channelLink : '',
      callCondition: WAITING,
    };
    try {
      const response = await createHLiveChatRequest(createRequestData, DECRYPT_FIRST_KEY, DECRYPT_SECOND_KEY);
      setIsLoading(true);
      // 필요항 state를 setting하기
      if (response?.success === true) {
        setRequestId(response?.data?.systemMessages[0]?.requestId);
        setRequestStatus(response?.data?.serviceRequest?.requestStatus);
        setExternalChannelType(createRequestData.externalChannelType);
        setExternalChannelLink(createRequestData.externalChannelLink);
        gtmCreateMiniChat();
        setFirebaseAuth();
        return response?.data?.systemMessages[0]?.requestId;
      } else if (response?.success === false) {
        setIsDialogOpened(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // ** -------------------------------------------------------------socket
  // socketInitializer
  const socketInitializer = async (requestId) => {
    const accessToken = getTokenFromStorage();
    const _socket = io(SOCKET_URI + SOCKET_NAMESPACE, {
      transports: ['websocket'],
      auth: {
        token: `Bearer ${accessToken}`,
        type: 'MINI_CHAT',
      },
    });

    _socket.on('connect', () => {
      consoleLogDev(`join, { roomId: ${requestId}' }`);
      _socket.emit('join', { roomId: requestId, sender: CUSTOMER });
    });

    _socket.on('disconnect', () => {
      consoleLogDev(`disconnect`);
    });

    _socket.on('chat', (msg) => {
      consoleLogDev('socket.on: chat', msg);
      setMessages((currentMsg) => [
        ...currentMsg,
        {
          ...msg.msg,
        },
      ]);
      _socket.emit('read', { roomId: requestId, sender: CUSTOMER });
    });

    _socket.on('checkChat', async ({ isTyping, roomId, isDownload, sender, ...args }) => {
      consoleLogDev(`socket,on: checkChat`);
      if (sender !== 'CUSTOMER') {
        if (isTyping && roomId === requestId) setIsTyping(true);
        else setIsTyping(false);
      }
    });

    _socket.on('read', async ({ sender }) => {
      consoleLogDev(`socket.on: read`);
      setMessages((prev) => prev.map((chat) => ({ ...chat, customerRead: true })));
      if (sender !== 'CUSTOMER') {
        setMessages((prev) => prev.map((chat) => ({ ...chat, dealerRead: true })));
      }
    });

    _socket.on('assign', async ({ roomId, sender }) => {
      consoleLogDev(`socket.on: assign, { roomId: ${roomId}, sender: ${sender}`);
      turnOnAlarm();
      try {
        const response = await getMessageListCustomer(requestId, DECRYPT_FIRST_KEY, DECRYPT_SECOND_KEY);

        if (response && requestStatus !== BLOCKED) {
          setRequestStatus(ASSIGNED);
          setMessages(response?.data);

          for (const item of response.data) {
            if (item.template === ASSIGNED) {
              setDealerInfo(item.systemMessageArgs[0]);
              break;
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    });

    setSocketInstance(_socket);

    return _socket;
  };

  // Notify socketInitializerNotify
  const socketInitializerNotify = async (requestId) => {
    const accessToken = getTokenFromStorage();
    const socketNotify = io(SOCKET_URI + SOCKET_NAMESPACE_NOTIFY, {
      transports: ['websocket'],
      auth: {
        token: `Bearer ${accessToken}`,
        type: 'MINI_CHAT',
      },
    });

    socketNotify.on('connect', () => {
      socketNotify.emit('join', { roomId: requestId, sender: CUSTOMER });
    });

    socketNotify.on('notify', () => {
      turnOnAlarm();
    });

    socketNotify.on('disconnect', () => {
      consoleLogDev(`socketNotify disconnect`);
    });

    socketNotify.on('block', () => {
      consoleLogDev('mini chat room ~ socket_notify.on ~ block');
      setRequestStatus(BLOCKED);
      turnOnAlarm();
    });

    socketNotify.on('terminateChat', () => {
      consoleLogDev('mini chat room ~ socket_notify.on ~ terminateChat');
      setRequestStatus(COMPLETED);
      turnOnAlarm();
    });

    setSocketInstanceNotify(socketNotify);
    return socketNotify;
  };

  // leaveSocket
  const leaveSocket = useCallback(() => {
    consoleLogDev('leave socket');
    setIsTyping(false);
    socketInstance.emit('leave', { roomId: requestId, sender: CUSTOMER });
    setRequestStatus('');
  }, [socketInstance, requestId]);

  // leaveSocketNotify
  const leaveSocketNotify = useCallback(
    (blockYn) => {
      consoleLogDev('leave socket Notify');
      socketInstanceNotify?.emit('leave', {
        roomId: requestId,
        sender: CUSTOMER,
        blockYn,
      });
      setRequestStatus('');
    },
    [socketInstanceNotify, requestId],
  );

  // ** -------------------------------------------------------------socket Initializer
  useEffect(() => {
    let socket;
    (async () => {
      socket = await socketInitializer(requestId);
    })();
    return () => {
      if (socket) {
        socket.disconnect();
      }
    };
  }, [requestId]);

  useEffect(() => {
    let socket;
    (async () => {
      socket = await socketInitializerNotify(requestId);
    })();
    return () => {
      if (socket) socket.disconnect();
    };
  }, [requestId]);

  // ** ---------------------------------------------------------------sessionStorage에서 Token를 받습니다.
  const getTokenFromStorage = () => {
    const tokenStorage = JSON.parse(sessionStorage.getItem(TOKEN_STORAGE));
    return tokenStorage?.token;
  };
  // 대신 새 WebSocket 연결이 생성되지 않습니다.
  // 메시지 변경 사항을 수신하고 checkChat 이벤트를 보냅니다.
  // message !== '', send "isTyping": true, 사용자가 입력 중임을 나타냅니다.
  // message === '', "isTyping" 전송: false, 사용자가 입력을 중단했음을 나타냅니다.
  useEffect(() => {
    const accessToken = getTokenFromStorage();
    const _socket = io(SOCKET_URI + SOCKET_NAMESPACE, {
      transports: ['websocket'],
      auth: {
        token: `Bearer ${accessToken}`,
        type: 'MINI_CHAT',
      },
    });

    // 간단한 code 사용할 수도 있지만 socket이 초기화되었는지 확인해야합니다.
    // if (!socketInstance) return;

    if (message !== undefined && message !== '') {
      _socket.emit('checkChat', { roomId: requestId, sender: 'CUSTOMER', isTyping: true });
    } else {
      _socket.emit('checkChat', { roomId: requestId, sender: 'CUSTOMER', isTyping: false });
    }
  }, [requestId, message]);

  // ** -------------------------------------------------------------API
  // getCallCenterCustomerHistory
  // history list 더 이상 필요 없지만 requestId를 통해서 해당 requestId의 setRequestStatus를 받아야합니다.
  const requestCallCenterHistory = async () => {
    try {
      const response = await getCallCenterCustomerHistory();
      if (response) {
        if (requestId) {
          const currentRequest = response.data.find((item) => item._id === requestId);
          if (
            currentRequest.requestStatus === COMPLETED ||
            currentRequest.requestStatus === 'CUSTOMER_AFK_P' ||
            currentRequest.requestStatus === 'CUSTOMER_AFK_Q'
          ) {
            setEndChat(true);
          }
          if (currentRequest) {
            setRequestStatus(currentRequest.requestStatus);
          } else {
            setRequestStatus('');
          }
        } else {
          setRequestStatus('');
        }
      }
    } catch (error) {
      console.error('Error in requestCallCenterHistory:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // 최신 RequestStatus 알기 위한 useEffect
  useEffect(() => {
    requestCallCenterHistory();
  }, [messages]);

  // getMessageListCustomer
  const fetchMessages = async () => {
    setIsMessageListLoading(true);
    try {
      if (requestId) {
        const response = await getMessageListCustomer(requestId, DECRYPT_FIRST_KEY, DECRYPT_SECOND_KEY);

        if (response) {
          setMessages(response.data);
          // EndChat확인
          const hasEndChatMessage = response.data.some((msg) => msg.messageType === 'H_LIVE_CHAT_END');
          if (hasEndChatMessage) {
            setEndChat(true);
          }
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsMessageListLoading(false);
    }
  };

  // getMiniChatToken
  const requestToken = async () => {
    const data = {
      ipAddress: getGenerationRandomString() + moment().format('YYYY-MM-DDTHH:mm:ssZ'),
      userType: GUEST,
      countryCode: selectedCountry?.countryCode,
      languageCode: selectedLanguage?.languageCode?.toLocaleUpperCase(),
    };

    try {
      const response = await getMiniChatToken(data);
      if (response) {
        const tokenStorage = {
          token: response?.data?.token,
          refreshToken: response?.data?.refreshToken,
        };
        sessionStorage.setItem(TOKEN_STORAGE, JSON.stringify(tokenStorage));
        return tokenStorage.token;
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 첫 loading시 token 확인.
  // token이 있는 경우 직접 requestCallCenterHistory 및 fetchMessages를 요청합니다.
  // token이 없는 경우 기준에 있는 chatting더 이상 이용할 수 없으모로 RequestId비우고 requestToken다시 생성하고  requestCallCenterHistory 요청합니다.
  useEffect(() => {
    const initializeData = async () => {
      consoleLogDev('initializeData');
      try {
        const tokenStorage = JSON.parse(sessionStorage.getItem(TOKEN_STORAGE));

        if (tokenStorage?.token) {
          await requestCallCenterHistory();
          fetchMessages();
        } else {
          setRequestId('');
          await requestToken();
          await requestCallCenterHistory();
        }
      } catch (error) {
        console.error(error);
      }
    };

    initializeData();
  }, []);

  // RequestId비우고 나서 RequestId갱신 후 fetchMessages요청합니다.
  useEffect(() => {
    if (requestId === '') {
      fetchMessages();
    }
  }, [requestId]);

  const initializeToken_test = () => {
    const tokenStorage = JSON.parse(sessionStorage.getItem(TOKEN_STORAGE));
    consoleLogDev('initializeToken_test ~ tokenStorage:', tokenStorage);
    return tokenStorage?.token ?? null;
  };

  // initializeToken(fetchData에 사용됨)
  const initializeToken = async () => {
    let tokenStorage = JSON.parse(sessionStorage.getItem(TOKEN_STORAGE));
    if (!tokenStorage?.token) {
      await requestToken();
      tokenStorage = JSON.parse(sessionStorage.getItem(TOKEN_STORAGE));
    }
    return tokenStorage.token;
  };

  // PrivacyPolicyUrl(fetchData에 사용됨)
  const requestPrivacyPolicyUrlMinichat = async (props) => {
    const { countryCode, setMinichatUrl } = props;
    try {
      const response = await getPrivacyPolicyByCountryCode(countryCode);
      setMinichatUrl(response[0]?.privacyPolicy[1].url);
    } catch (e) {
      console.error(e);
    }
  };

  // getBusinessHourByCountry(getOnlineStatus 사용됨)
  const requestBusinessHourByCountry = async () => {
    try {
      const response = await getBusinessHourByCountry();
      if (response) {
        return response;
      }
    } catch (error) {
      console.error(error);
    }
  };

  // getOnlineStatus (fetchData에 사용됨)
  const getOnlineStatus = async () => {
    const businessHourData = await requestBusinessHourByCountry();
    const scheduleData = businessHourData?.data;
    const isOnline = checkIsOnline(
      scheduleData,
      setStartTime,
      setEndTime,
      setIncludeBreakStartTime,
      setIncludeBreakEndTime,
      setIsIncludeBreak,
      selectedCountry,
    );
    return { isOnline, scheduleData, businessHourData };
  };

  // handleRoomEntry(fetchData에 사용됨)
  const handleRoomEntry = async (isOnline, scheduleData) => {
    if (isOnline) {
      setIsOffline(false);
    } else if (scheduleData === HOLIDAY) {
      setRequestStatus(HOLIDAY);
      setIsOffline(true);
    } else {
      setRequestStatus('');
      setIsOffline(true);
    }
  };

  // fetchData useEffect
  // requestId 또는 selectedCountry가 변경될 때 fetchData()를 실행하고 다음 용도로 사용됩니다.
  useEffect(() => {
    const fetchData = async () => {
      // setIsLoading(true);
      const token = await initializeToken();
      if (!token) {
        consoleLogDev('fetchData ~ token:', token);
        setCanSendMessage(false);
        return;
      }

      try {
        const countryCode = selectedCountry?.countryCode;
        // 온라인 상태 가져오기(getOnlineStatus())
        // 개인정보 보호정책 URL 받기(requestPrivacyPolicyUrlMinichat())
        // Promise.all([...])을 사용하면 두 개의 API 요청을 동시에 실행합니다.
        // getOnlineStatus() 및 requestPrivacyPolicyUrlMinichat()은 종속성이 없으며 동시 실행될 수 있습니다.
        // API 호출 시간 단축 및  로딩 시간을 줄이기
        const [onlineStatusData, privacyPolicyResponse] = await Promise.all([
          getOnlineStatus(),
          requestPrivacyPolicyUrlMinichat({ countryCode, setMinichatUrl }),
        ]);

        const { isOnline, scheduleData, businessHourData } = onlineStatusData;

        // 업무 시간 데이터가 유효한 경우(businessHourData.success), handlerRoomEntry()를 실행합니다.
        if (businessHourData?.success) {
          await handleRoomEntry(isOnline, scheduleData);
        }

        // PrivacyPolicyResponse를 통해 MinichatUrl(PrivacyPolicy)확득합니다.
        if (privacyPolicyResponse?.length > 0 && privacyPolicyResponse[0]?.privacyPolicy?.length > 1) {
          setMinichatUrl(privacyPolicyResponse[0].privacyPolicy[1].url);
        }

        setCanSendMessage(true);
      } catch (error) {
        console.error(error);
        setCanSendMessage(false);
      }
    };

    fetchData();
  }, [requestId, selectedCountry]);

  // ** ---------------------------------------------------------------textFieldRef & scrollViewRef
  useEffect(() => {
    if (!sending) {
      textFieldRef?.current?.focus();
    }
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTop = scrollViewRef.current.scrollHeight;
    }
  }, [sending, messages]);

  useEffect(() => {
    if (textFieldRef.current) {
      const maxRows = 3;
      const rows = textFieldRef.current.value.split('\n').length;
      textFieldRef.current.style.padding = rows > maxRows ? '12px 0 0 20px' : '12px 20px 0';
    }
  }, [requestId, message]);

  // haveChatFromDealer
  const haveChatFromDealer = Array.isArray(messages) && messages.some((msg) => msg.writer === 'DEALER');

  return (
    <Box sx={styles.container}>
      {/* chat unavailable */}
      {isDialogOpened && <Box sx={styles.overlay} />}
      {isDialogOpened && (
        <CustomDialog
          isOpen={isDialogOpened}
          styles={styles}
          t={t}
          onClose={() => {
            leaveSocketNotify();
            leaveSocket();
          }}
        />
      )}

      {/* PrivacyPolicy */}
      {isDisclaimerOpened && <Disclaimer styles={styles} t={t} handleDisclaimer={handleDisclaimer} minichatUrl={minichatUrl} />}

      {/* CustomHeader */}
      <CustomHeader
        styles={styles}
        t={t}
        requestId={requestId}
        requestStatus={requestStatus}
        endChat={endChat}
        handleFoldClick={handleFoldClick}
        handleCloseClick={handleCloseClick}
      />

      {/* LoadingSpinner */}
      <Box sx={styles.chatWrapper} ref={scrollViewRef}>
        {(isLoading || isMessageListLoading) && (
          <Box sx={styles.spinnerBox}>
            <LoadingSpinner />
          </Box>
        )}

        {/* isOffline시  */}
        {isOffline && (
          <OfflineMessage
            styles={styles}
            t={t}
            currentDate={currentDate}
            isIncludeBreak={isIncludeBreak}
            startTime={startTime}
            endTime={endTime}
            includeBreakStartTime={includeBreakStartTime}
            includeBreakEndTime={includeBreakEndTime}
          />
        )}

        {/* requestStatus의 type이랑 맞는 UI  */}
        {requestStatus !== HOLIDAY && isOffline === false && (
          <Box ref={scrollViewRef} flex={1} sx={styles.chatContainer}>
            {/* welcome system message */}
            <Box sx={styles.systemMessage}>
              <Typography sx={styles.systemText}>{t('4510_chat_in_progress.welcome_to_hyundai_assistant')}</Typography>
              <Typography sx={styles.systemText}>{t('4510_chat_in_progress.feel_free_to_leave_us_a_message')}</Typography>
              <Typography sx={styles.systemText}>{t('4510_chat_in_progress.we_will_get_back_to_you_shortly')}</Typography>
            </Box>
            {messages?.map((msg, i) => {
              let isFirstItem = true;

              if (i > 0) {
                isFirstItem = !(commonDateFormat(messages[i - 1].createDate) === commonDateFormat(msg.createDate));
              }
              return (
                <ChatBubble
                  key={i}
                  msg={msg}
                  dealerInfo={dealerInfo}
                  isFirstItem={isFirstItem}
                  isOffline={isOffline}
                  imageDialogOpen={imageDialogOpen}
                  setImageDialogOpen={setImageDialogOpen}
                  onImageLoadEnd={(e) => {
                    if (scrollViewRef.current) {
                      scrollViewRef.current.scrollTop = scrollViewRef.current.scrollHeight;
                    }
                  }}
                />
              );
            })}

            {/* isTyping */}
            {isTyping && (
              <>
                <Box sx={styles.typingBox}>
                  <Typography sx={styles.typingText}>
                    <Box sx={styles.typingImage}>
                      <img width={37} height={7} src={typing} alt="typing" />
                    </Box>
                  </Typography>
                </Box>
              </>
            )}

            {/* FINISHED */}
            {requestStatus === FINISHED && (
              <Box sx={styles.submitted}>
                <Typography style={styles.ratingTitle}>{t('4520_chat_ratings.thank_you_for_sharing_your_experience')}</Typography>
              </Box>
            )}

            {/* COMPLETED */}
            {haveChatFromDealer && (requestStatus === COMPLETED || requestStatus === 'CUSTOMER_AFK_P') && (
              <RatingForm
                styles={styles}
                t={t}
                isLoading={isLoading}
                qualityRating={qualityRating}
                satisfactionRating={satisfactionRating}
                handleQualityRatingChange={handleQualityRatingChange}
                handleSatisfactionRatingChange={handleSatisfactionRatingChange}
                handleSubmit={handleSubmit}
              />
            )}
          </Box>
        )}
      </Box>

      {/* send message part */}
      {endChat ||
      requestStatus === 'FINISHED' ||
      requestStatus === 'COMPLETED' ||
      requestStatus === 'CUSTOMER_AFK_P' ||
      requestStatus === 'CUSTOMER_AFK_Q' ? (
        <Box sx={styles.chatInput}>
          <Box
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '12px 20px', borderTop: `1px solid ${color.grey_300}` }}
          >
            <Box
              sx={{
                width: '332px',
                height: '50px',
                background: '#002D63',
                fontFamily: 'HyundaiHeadMedium',
                fontSize: '16px',
                fontWeight: 400,
                lineHeight: '20px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#fff',
                cursor: 'pointer',
              }}
              onClick={() => {
                setEndChat(false);
                setRequestStatus('');
                setRequestId('');
                setMessages([]);
              }}
            >
              {t('4540_chat_end.start_a_new_chat')}
            </Box>
          </Box>
        </Box>
      ) : (
        (requestStatus === REQUESTED || requestStatus === ASSIGNED || requestStatus === '') &&
        isOffline === false && (
          <Box
            sx={styles.chatInput}
            className={requestStatus === REQUESTED || requestStatus === ASSIGNED || requestStatus === '' ? '' : 'chat-input-disabled'}
          >
            <Box sx={styles.chatInputContainer}>
              <TextField
                id="chat-input"
                value={message}
                disabled={sending}
                multiline
                maxRows={3}
                placeholder={t('0500_live_consult.please_enter_a_chat')}
                onChange={(e) => setMessage(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                  } else return true;
                }}
                onKeyUp={handleKeyPress}
                inputRef={textFieldRef}
                focused={!sending}
                autoFocus
                sx={styles.chatInputfield}
              />

              <Box sx={styles.chatToolBox}>
                <Button disabled={sending || !message || !canSendMessage} sx={styles.button} onClick={handleSendButton}>
                  {message && message.trim() !== '' && canSendMessage ? (
                    <img style={styles.chatSendIcon} src={icon_send} alt={icon_send} />
                  ) : (
                    <img style={styles.chatSendIcon} src={icon_send_disabled} alt={icon_send_disabled} />
                  )}
                </Button>
              </Box>
            </Box>
          </Box>
        )
      )}

      <Box sx={styles.footer}>
        <Button target="_blank" sx={[styles.disclaimer]} onClick={handleDisclaimer}>
          {t('4530_chat_common.privacy_info')}
        </Button>
        <Typography sx={styles.footerText}>{t('4530_chat_common.powered_by_wondermove')}</Typography>
      </Box>

      <CustomModal
        open={openEndChatModal}
        onClose={handleEndChatModalClose}
        content={t('4540_chat_end.do_you_want_to_end_the_chat')}
        onButtonOneClick={handleEndChatModalClose}
        onButtonTwoClick={handleConfirmEndChat}
      />
    </Box>
  );
};

export default MiniChatRoomSingle;

// ** ---------------------------------------------------------------checkIsOnline
const checkIsOnline = (
  scheduleData,
  setStartTime,
  setEndTime,
  setIncludeBreakStartTime,
  setIncludeBreakEndTime,
  setIsIncludeBreak,
  selectedCountry,
) => {
  const { startTime, endTime, includeBreakEndTime, includeBreakStartTime, isIncludeBreak } = scheduleData;
  //국가에 맞은 Timezone
  const countryToTimezone = {
    en: 'Europe/London',
    it: 'Europe/Rome',
    no: 'Europe/Oslo',
    sk: 'Europe/Bratislava',
    nl: 'Europe/Amsterdam',
    cs: 'Europe/Prague',
    pl: 'Europe/Warsaw',
    fr: 'Europe/Paris',
    es: 'Europe/Madrid',
    se: 'Europe/Stockholm',
  };

  setStartTime(startTime);
  setEndTime(endTime);
  setIncludeBreakStartTime(includeBreakStartTime);
  setIncludeBreakEndTime(includeBreakEndTime);
  setIsIncludeBreak(isIncludeBreak);

  const timezone = countryToTimezone[selectedCountry.countryCode.toLowerCase()] || 'UTC';
  // ** moment time module install요청해야해서 일단 getTimeInTimeZone을 쓰고있음
  // const currentTime = moment().tz(timezone).format('HH:mm');
  const currentTime = getTimeInTimeZone(timezone);
  // console.log('currentTime:', currentTime);

  if (isIncludeBreak) {
    return (startTime <= currentTime && currentTime <= endTime) || (includeBreakStartTime <= currentTime && currentTime <= includeBreakEndTime);
  } else {
    return startTime <= currentTime && currentTime <= endTime;
  }
};

const getTimeInTimeZone = (timezone) => {
  return new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date());
};
